import { Currency } from "../hooks/useCurrency";

const CurrencyToggle = ({
  currency,
  onChange,
}: {
  currency: Currency;
  onChange: (value: Currency) => void;
}) => (
  <div className="inline-flex rounded-[5px] border-2 border-solid border-[#F2F1F1] overflow-hidden text-sm font-medium">
    {(["NGN", "USD"] as Currency[]).map((c) => (
      <button
        key={c}
        type="button"
        onClick={() => onChange(c)}
        className={`px-4 py-2 ${
          currency === c
            ? "bg-honeConnectPurple text-white"
            : "bg-[#F8F8F8] text-honeConnectGray"
        }`}
      >
        {c === "NGN" ? "₦ NGN" : "$ USD"}
      </button>
    ))}
  </div>
);

export default CurrencyToggle;
